import ProductInfoPanel from "./productInfoPanel.container";

export default ProductInfoPanel;
